import { createCrudApi } from './crud';
import { apiClient } from './client';
import type { ApiSuccess } from '../types';

export interface Client {
  id: number;
  clientCode: string;
  clientName: string;
  gstNumber: string | null;
  panNumber: string | null;
  address: string | null;
  contactPerson: string | null;
  email: string | null;
  mobile: string | null;
  status: 'active' | 'inactive';
  createdAt: string;
  profileStatus?: 'complete' | 'incomplete_details' | 'incomplete_documents';
  detailsComplete?: boolean;
  documentsComplete?: boolean;
}

export interface CreateClientInput {
  clientName: string;
  gstNumber?: string;
  panNumber?: string;
  address?: string;
  contactPerson?: string;
  email?: string;
  mobile?: string;
  status?: 'active' | 'inactive';
}

export const clientsApi = createCrudApi<Client, CreateClientInput>('clients');

/** A business vertical (service) a client is mapped to. */
export interface ClientVertical {
  id: number;
  verticalId: number;
  code: string;
  name: string;
  status: string;
}

/** Manage which business verticals / services a client is mapped to (client_verticals). */
export const clientVerticalsApi = {
  async list(clientId: number): Promise<ClientVertical[]> {
    return (await apiClient.get<ApiSuccess<ClientVertical[]>>(`/clients/${clientId}/verticals`)).data.data;
  },
  async assign(clientId: number, verticalId: number): Promise<ClientVertical[]> {
    return (await apiClient.post<ApiSuccess<ClientVertical[]>>(`/clients/${clientId}/verticals`, { verticalId })).data.data;
  },
  async revoke(clientId: number, verticalId: number): Promise<ClientVertical[]> {
    return (await apiClient.delete<ApiSuccess<ClientVertical[]>>(`/clients/${clientId}/verticals/${verticalId}`)).data.data;
  },
};
